<template>
  <div
    :class="{ 'm-b-10': $store.state.edit.on }"
    class="editable block"
    @mouseover="hover = true"
    @mouseout="hover = false"
  >
    <div v-if="!editing || !isMe || !$store.state.edit.on">
      <div v-if="isMe && $store.state.edit.on" class="link block" @click="edit">
        <div class="row">
          <div class="col-sm-4">
            <a href="#">{{ data.title }}</a>
            <i v-show="hover && !loader" class="zmdi zmdi-edit c-gray m-l-10"></i>
          </div>
          <div class="col-sm-8 m-h-20" style="margin-top: -15px">
            <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
            <NetworkLoader :loader="loader" :failed="failed" />
          </div>
        </div>
      </div>
      <div v-else>
        <a :href="data.url" target="_blank" rel="noopener noreferrer">
          {{ data.title }}
        </a>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-sm-5 p-r-0">
        <!-- eslint-disable vue/no-mutating-props -->
        <input
          v-model="data.title"
          :placeholder="$t('Add link text here')"
          class="form-control f-14"
          style="width: 100%"
          type="text"
          @keyup.enter="saveChanges"
        />
        <!-- eslint-enable-->
      </div>
      <div class="col-sm-4 p-r-0">
        <input
          v-model="data.url"
          :placeholder="$t('Add link URL here')"
          class="form-control f-14"
          style="width: 100%"
          type="text"
          @keyup.enter="saveChanges"
        />
      </div>
      <div class="col-sm-3">
        <button class="btn btn-success" @click.prevent="saveChanges">
          <i class="zmdi zmdi-floppy" />
        </button>
        <button class="btn btn-danger" @click.prevent="deleteMe">
          <i class="zmdi zmdi-delete" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_EDIT_UNSAVED } from '@/state/mutation-types'

export default {
  name: 'ComponentEditLinks',
  props: {
    isMe: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editing: false,
      loader: false,
      failed: false,
      hover: false,
      old: {},
    }
  },
  watch: {
    '$store.state.edit.on': function (setting) {
      if (!setting && this.editing) {
        // We just turned off edit on the global button, and we are still in editing mode
        this.saveChanges()
      }
    },
  },
  created() {
    this.old.title = this.data.title
    this.old.url = this.data.url
    if (!this.data.hasOwnProperty('url')) {
      // We have a new object, so we add some standard data
      // eslint-disable-next-line vue/no-mutating-props -- Baseline eslint ignore please fix if working on this
      this.data.url = ''
      // eslint-disable-next-line vue/no-mutating-props -- Baseline eslint ignore please fix if working on this
      this.data.title = ''
      this.editing = true

      // We also lock our page, until we either delete or save the current object
      this.$store.commit(SET_EDIT_UNSAVED, true)
    }
  },
  methods: {
    edit() {
      if (this.isMe) {
        this.$store.commit(SET_EDIT_UNSAVED, true)
        this.editing = true
      }
    },
    saveChanges() {
      this.editing = false
      this.loader = true
      this.hover = false
      this.$emit('save-changes', this.data.k)
      setTimeout(() => {
        this.loader = false
      }, 1000)

      if (this.old.url !== this.data.url || this.old.title !== this.data.title) {
        this.loader = true
        this.hover = false
        this.old.title = this.data.title
        this.old.url = this.data.url
        setTimeout(() => {
          this.loader = false
          this.$store.commit(SET_EDIT_UNSAVED, false)
        }, 1000)
      }
    },
    deleteMe() {
      this.editing = false
      this.loader = true
      this.hover = false
      this.$emit('delete', this.data.k)
      this.$store.commit(SET_EDIT_UNSAVED, false)
      setTimeout(() => {
        this.loader = false
      }, 1000)
    },
  },
}
</script>

<style scoped lang="scss"></style>
